<template>
  <label class="radio-container"
         :class="[{ disable }]">
    <input
      :checked="checked"
      :class="{ checked }"
      :disabled="disable"
      :name="inputName"
      type="radio"
      :value="value"
      @change="onChange"
    />
    <span class="custom-radio"/>
    <span class="label">{{ label }}</span>
    <div v-if="hint"
         class="hint">
      <vsx-icon color="#4D4D4D"
                icon-name="InfoCircle"
                :size="14"
                type="linear" />
      <p class="hint__content">{{ hint }}</p>
    </div>
  </label>
</template>

<script>
  export default {
    name: 'BevaRadio',
    props: {
      label: {
        type: [String, Number],
        required: true,
      },
      checked: {
        type: Boolean,
        required: false,
      },
      inputName: {
        type: String,
        required: true,
      },
      value: {
        type: [String, Number, Boolean],
        required: true,
      },
      hint: {
        type: String,
        required: false,
      },
      disable: {
        type: Boolean,
        required: false,
      },
    },
    emits: ['onCheck', 'onChange'],
    methods: {
      onChange() {
        if (this.disable) {
          return;
        }
        this.$emit('onChange', this.value);
        this.$emit('onCheck', this.value);
      },
    },
  };
</script>

<style lang="scss" scoped>
.radio-container {
  display: flex;
  align-items: center;
  gap: 8px;
  user-select: none;
  cursor: pointer;

  &.disable {
    cursor: not-allowed;
    .custom-radio::before {
      width: 24px;
      height: 24px;
      background-color: #ddd;
      border: 1px solid #808080;
      box-sizing: border-box;
      opacity: 0.6;
    }
  }

  input[type='radio'] {
    display: none;
  }

  .label {
    font-size: 12px;
    color: var(--gray700, #4d4d4d);
  }

  .custom-radio {
    position: relative;
    width: 24px;
    height: 24px;
  }
  .custom-radio::before,
  .custom-radio::after {
    content: '';
    position: absolute;
    border-radius: 50%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .custom-radio::before {
    width: 24px;
    height: 24px;
    background-color: white;
    border: 1px solid #808080;
    box-sizing: border-box;
  }
  input:checked + .custom-radio::before,
  .checked + .custom-radio::before {
    background-color: var(--color-base-100);
    border: 1px solid var(--color-base-500);
  }
  input:checked + .custom-radio::after,
  .checked + .custom-radio::after {
    width: 16px;
    height: 16px;
    background-color: var(--color-base-500);
  }
}

.hint {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover &__content {
    opacity: 1;
  }
  &__content {
    opacity: 0;
    position: relative;
    top: -22px;
    padding: 8px;
    font-size: 12px;
    font-weight: 300;
    border-start-start-radius: 8px;
    border-start-end-radius: 8px;
    border-end-end-radius: 8px;
    color: white;
    background-color: #232f34;
    z-index: 10;
  }
}
</style>
